module.exports = __webpack_public_path__ + "static/53-daf78140415e86edc757dcb2ad32e311.png";